import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-[#f5f0e6]" data-id="element-249">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-251">
          <h2 className="md:text-4xl font-extrabold text-[#1a3622] mb-6 text-balance text-[20px]" data-id="element-252">
            ❓ ¿TE SUENA CONOCIDO ESTO?
          </h2>

          <div className="space-y-6 text-lg text-[#4a3b32] text-left md:text-center max-w-3xl mx-auto" data-id="element-253">
            <p className="text-[16px]" data-id="element-254">
              Domingo a las 11 de la noche. Mañana tenés clase de ganadería o
              producción sustentable. Y todavía estás buscando cómo explicar la
              diferencia entre suelos francos y arcillosos, o cómo presentar el
              ciclo reproductivo bovino sin que tus alumnos se pierdan en la
              primera diapositiva.
            </p>
            <p data-id="element-255">
              <strong className="text-[#1a3622] text-[18px]" data-id="element-256">
                No es tu culpa. Es que llevás años peleando con manuales
                técnicos desactualizados, documentación dispersa y materiales
                pensados para otros contextos que después tenés que reescribir
                entero para adaptarlos al aula agrotécnica.
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}